import React from 'react'
import ItemSocialNetwork from './ItemSocialNetwork/ItemSocialNetwork'

const SocialNetwork = ({ data }: any) => {
  return <ItemSocialNetwork data={data} />
}

export default SocialNetwork
